import axios from "axios";
import React, { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { useSelector } from "react-redux";
import tw from "tailwind-styled-components";
import Loading from "../../Components/Loading";
import Navbar from "../../Components/Navbar";
import NotFoundModel from "../../Components/NotFoundModel";
import {
  Bg,
  BoxContainer,
  Button,
  Underline,
} from "../../Components/Styles/PageStyles";
import Config from "../../Config";
import Images from "../../Images";
import { toast } from "react-toastify";
import { MdAdd } from "react-icons/md";
import AddCategory from "../../Components/FoodCategory/AddCategory";
import EditCategory from "../../Components/FoodCategory/EditCategory";
import Table from "../../Components/FoodCategory/Table";

export const FoodCategory = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const [selectedData, setSelectedData] = useState();
  const [addFoodCategory, setAddFoodCategory] = useState(false);
  const [apiData, setApiData] = useState();
  const [editFoodCategory, setEditFoodCategory] = useState(false);

  
  const fetchData = async () => {
    const body = new FormData();
    return await axios.post(`${Config.apiUrl}/getinventory`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onDataSuccess = (res) => {
    if (res.data.status == "NOK" || res.data.data == false) error = true;
    setApiData(res.data);
  };

  const onDataError = (data) => {};

  useEffect(() => {
    const handler = setTimeout(() => {
      DataMutate();
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, []);

  const {
    isLoading: isDataLoading,
    mutate: DataMutate,
    error,
    data,
  } = useMutation(fetchData, {
    onSuccess: onDataSuccess,
    onError: onDataError,
  });

//-------Add Category------------------------------------------------
  const onAddCategory = async (values) => {
    const body = new FormData();

    Object.keys(values).forEach((i) => body.append(i, values[i]));

    return await axios.post(`${Config.apiUrl}/addinventorycategory`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onAddSuccess = (data) => {
    toast.success(data?.data?.msg || "Success");
    setApiData(data?.data);
    setAddFoodCategory(false);
  };

  const onAddError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
    setAddFoodCategory(false);
  };

  const { isLoading: addCategoryLoading, mutate: addCategoryMutate } =
    useMutation(onAddCategory, {
      onSuccess: onAddSuccess,
      onError: onAddError,
    });

//--------------Edit Category----------------------------------------------    
  const onEditCategory = async (values) => {
    const body = new FormData();

    Object.keys(values).forEach((i) => body.append(i, values[i]));

    return await axios.post(`${Config.apiUrl}/editinventorycategory`, body, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onEditSuccess = (data) => {
    toast.success(data?.data?.msg || "Success");
    setApiData(data?.data);
    setEditFoodCategory(false);
  };

  const onEditError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
    setEditFoodCategory(false);
  };

  const { isLoading: editCategoryLoading, mutate: editCategoryMutate } = useMutation(
    onEditCategory,
    {
      onSuccess: onEditSuccess,
      onError: onEditError,
    }
  );


  return (
    <>
      <Bg
        style={{
          backgroundImage: `url(${Images.BeamsBg})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
          backgroundPosition: "top left",
          height: "100vh",
        }}
      >
        <Navbar />
        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>Inventory Categories</Title>
              <Underline />
            </div>
            <UploadWrapper>
              <Button type="button" onClick={() => setAddFoodCategory(true)}>
                <MdAdd className="text-white w-5 h-5" />{" "}
                <p className="text-sm">{"Add Category"}</p>
              </Button>
            </UploadWrapper>
          </div>
          {editFoodCategory && (
            <EditCategory
              setEditFoodCategory={setEditFoodCategory}
              selectedData={selectedData}
              editCategoryLoading={editCategoryLoading}
              editCategoryMutate={editCategoryMutate}
            />
          )}
          {addFoodCategory && (
            <AddCategory
              setAddFoodCategory={setAddFoodCategory}
              addCategoryLoading={addCategoryLoading}
              addCategoryMutate={addCategoryMutate}
            />
          )}
          {!error && !isDataLoading && data && (
            <TableWrapper>
              <Table
                ApiData={apiData?.data}
                setSelectedData={setSelectedData}
                userType={user.userType}
                selectedData={selectedData}
                setEditFoodCategory={setEditFoodCategory}
              />
              {(error || apiData?.msg == "No data found") && !isDataLoading && (
                <NotFoundModel />
              )}
            </TableWrapper>
          )}

          {isDataLoading && <Loading />}
        </BoxContainer>
      </Bg>
    </>
  );
};
const Title = tw.h1`text-xl w-full text-gray-800 whitespace-nowrap font-medium flex justift-center`;
const TableWrapper = tw.h1`my-10 border  bg-white rounded-md `;
const UploadWrapper = tw.div`w-full flex justify-end space-x-4 items-center `;
